import script from "./ExpandedFilterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandedFilterComponent.vue?vue&type=script&setup=true&lang=js"

import "./ExpandedFilterComponent.vue?vue&type=style&index=0&id=b335404c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b335404c"]])

export default __exports__